(ns vit-configurator.views.title
  (:require [re-frame.core :as re-frame]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]))

(defn customizer
  []
  (let [title @(re-frame/subscribe [::subs/title])]
    [:fieldset#title
     [:legend "Provide a title for the Voting Information Tool"]
     [:label.pr-4 {:for "title"} "Custom Landing Page Title"]
     [:div
      [:input#title.mb-0.mw-100
       {:type "text" :name "title" :value (or title "")
        :on-change (fn [evt]
                     (let [val (.. evt -target -value)]
                       (re-frame/dispatch [::events/set-title val])))}]]]))
